import { createTheme, ThemeOptions } from '@mui/material';

const colorOptions = createTheme({
    palette: {
        primary: {
            // change color of scrollbar in index.css
            main: '#63c993',
            light: '#63c99377',
            contrastText: 'rgba(255,255,255,0.87)',
        },
        secondary: {
            main: '#887EF2',
            contrastText: 'rgba(255,255,255,0.87)',
            light: '#887EF233   ',
        },
        background: {
            default: '#e2e8f0',
            paper: '#f8fafc',
        },
        error: {
            main: '#F25D4E',
        },
    },
});

const themeOptions: ThemeOptions = {
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    margin: '2px',
                },
                textPrimary: {
                    background: `${colorOptions.palette.secondary.main}10`,
                    ':hover': {
                        background: `${colorOptions.palette.secondary.main}40`,
                    },
                    ':focus': {
                        background: `${colorOptions.palette.secondary.main}40`,
                    },
                },
                textError: {
                    ':hover': {
                        background: `${colorOptions.palette.error.main}40`,
                    },
                    ':focus': {
                        background: `${colorOptions.palette.error.main}40`,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    background: `${colorOptions.palette.secondary.main}10`,
                    '& fieldset': { border: 'none', color: 'red' },

                    ' .MuiInputLabel-root': {
                        color: `${colorOptions.palette.primary.main}`,
                    },
                    '.MuiOutlinedInput-root': {
                        color: `${colorOptions.palette.primary.main}`,
                    },
                    '.MuiSvgIcon-root': {
                        color: `${colorOptions.palette.primary.main}`,
                    },
                },

            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    border: '1px #eee solid',
                    background: 'white',
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    background: '#f3f6f9',
                    '& .MuiTableCell-head': {
                        color: '#7c7c7c',
                        fontWeight: 'bold',
                        textAlign: 'left',
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '12px',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    marginRight: '8px',
                    padding: '2px',
                    '& .MuiChip-filled': {
                        backgroundColor: 'red',
                    },
                    '& .MuiChip-outlined': {
                        color: 'green',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                },
                paper: {
                    borderRadius: '16px',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    // background: colorOptions.palette.primary.main,
                    display: 'flex',
                    justifyContent: 'space-between',
                    // color: 'white',
                    fontWeight: 'bolder',
                    fontSize: '24px',

                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    // background: '#eee',

                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    // background: '#eee',

                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    ':hover': {
                        background: '#eee',
                    },
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    whiteSpace: 'normal',
                    // Adjacent Sibling Selector for divider.
                    '+ .MuiDivider-root': {
                        margin: '0px',
                    },
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                body2: {
                    color: colorOptions.palette.primary.main,
                    fontSize: 18,
                    fontWeight: 600,
                },
            },
        },
    },
};

const mdTheme = createTheme(colorOptions, themeOptions);

export default mdTheme;
